<script lang="ts" setup>
	const props = defineProps<{
		planDetails: unknown
		fill?: boolean
		pending?: boolean
	}>()
	const statusSteps = computed(() => {
		const steps: Record<
			'error' | 'success' | 'ongoing' | 'pending' | 'paused',
			{
				message: string
				status: boolean
			}
		> = {
			error: {
				message: '',
				status: false
			},
			success: {
				message: '',
				status: false
			},
			ongoing: {
				message: '',
				status: false
			},
			paused: {
				message: '',
				status: false
			},
			pending: {
				message: '',
				status: false
			}
		}

		if (
			props.planDetails?.is_pending &&
			!props.planDetails?.is_deactivated &&
			!props.planDetails?.to_be_deactivated &&
			!props.planDetails?.to_be_removed
		) {
			if (props.planDetails?.meta?.is_paused) {
				steps.error.message = 'Paused'
				steps.error.status = true
			} else {
				steps.pending.message = 'pending'
				steps.pending.status = true
			}
		} else if (
			props.planDetails?.is_deactivated ||
			props.planDetails?.to_be_deactivated ||
			props.planDetails?.is_expired ||
			props.planDetails?.to_be_removed ||
			props.planDetails?.to_be_terminated ||
			props.planDetails?.is_terminated
		) {
			steps.error.status = true
			if (props.planDetails?.is_deactivated) {
				steps.error.message = 'deactivated'
			} else if (props.planDetails?.is_expired) {
				steps.error.message = 'expired'
			} else if (props.planDetails?.is_terminated) {
				steps.error.message = 'terminated'
			} else if (props.planDetails?.to_be_terminated) {
				steps.error.message = 'awaiting termination'
			} else if (props.planDetails?.to_be_deactivated || props.planDetails?.to_be_removed) {
				steps.error.message = 'awaiting deactivation'
			}
		} else if (props.planDetails?.to_be_downgraded || props.planDetails?.to_be_upgraded) {
			steps.ongoing.status = true
			steps.ongoing.message = props.planDetails?.to_be_downgraded ? 'awaiting downgrade' : 'awaiting upgrade'
		} else {
			steps.success.status = true
			steps.success.message = props.pending ? 'waiting' : 'active'
		}

		return steps
	})
</script>

<template>
	<div>
		<shared-badge
			:text="
				statusSteps.error.message ||
				statusSteps.ongoing.message ||
				statusSteps.success.message ||
				statusSteps.pending.message
			"
			:active="!pending && statusSteps.success.status"
			:pending="statusSteps.pending.status"
			:failed="statusSteps.error.status"
			:ongoing="pending || statusSteps.ongoing.status"
			class="inline-flex whitespace-nowrap text-xs font-medium"
			:fill="fill"
		>
			<slot />
		</shared-badge>
	</div>
</template>
